(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["events-collabs"] && !Shopify.designMode) return;
  try {
    
  // A cached render can hold an event whose day has passed in the upcoming band (CONTENT_MODEL.md
  // L7). Remove it in the visitor's own calendar, and show the empty line if nothing is left.
  (function () {
    function prune() {
      var now = new Date();
      var today = now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
      document.querySelectorAll('[data-ec-upcoming]').forEach(function (list) {
        list.querySelectorAll('[data-sdw-ends]').forEach(function (card) {
          var ends = parseInt(card.dataset.sdwEnds.replace(/-/g, ''), 10);
          if (ends && ends < today) card.remove();
        });
        if (!list.querySelector('[data-sdw-ends]')) {
          list.hidden = true;
          var empty = list.parentElement.querySelector('[data-ec-empty]');
          if (empty) empty.hidden = false;
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', prune);
    } else {
      prune();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reasons-buy"] && !Shopify.designMode) return;
  try {
    
  // The icons are drawn at rest. This only adds the class that lets them draw themselves
  // in once, on the cards a visitor has actually scrolled to; the CSS keeps the animation
  // inside `prefers-reduced-motion: no-preference`, so nothing here needs to test for it.
  (function () {
    var SELECTOR = '.reasons-buy__item:not(.is-drawing)';

    function watch(root) {
      var items = (root || document).querySelectorAll(SELECTOR);

      if (!items.length) return;

      // No IntersectionObserver means no trigger, and the resting state is already the
      // finished icon — so there is nothing to fall back to and nothing to fix.
      if (!('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-drawing');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.3 }
      );

      items.forEach(function (item) {
        observer.observe(item);
      });
    }

    watch();

    // The theme editor re-renders a section in place; its cards arrive without the class.
    document.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
